/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import Vue from 'vue';
import Vuex, { createLogger } from 'vuex';

Vue.use(Vuex);

// Plugin Vuex Persistance
import { createVuexPersistance } from './vuex-persistance-plugin';

// Global
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

// Module
import auth from './auth/module-auth';
import user from './user/module-user';
import organization from './organization/module-organization';
import invoice from './invoice/module-invoice';
import invoicefiles from './invoicefiles/module-invoicefiles';
import inbox from './inbox/module-inbox';
import notification from './notification/module-notification';
import supplier from './supplier/module-supplier';
import licenseinfo from './licenseinfo/module-licenseinfo';
import resource from './resources/module-resource';
import invoicesCheckingUpdate from './invoicesCheckingUpdate/module-invoice-checking-update';
import layout from './layout/module-layout';
import columnexport from './columnexport/module-column-export';
import stick from './stick/module-stick';
import invoicetrial from './invoicetrial/module-invoicetrial';
import auditinglog from './auditinglog/module-auditinglog';
import agreement from './licenseagreement/module-agreement';
import connectInvoice from './connectInvoice/module-connect-invoice';
import misaid from './misaid/module-misaid';
import settingsystem from './setting/module-setting';
import rolepermission from './role/module-role';
import outinvoice from './outinvoice/module-outinvoice';
import versionfeature from './versionFeature/module-feature';
import notificationuser from './notificationUser/module-notification-user';
import internal from './internal/module-internal';
import organizationtransferinvoice from './organizationTransferInvoice/module-organization-transfer';
import suppliernodowninv from './suppliernodowninv/module-supplier-no-down';
import supplieronlydowninv from './supplieronlydowninv/module-supplier-only-down';
import transferinvbytaxcode from './transferinvbytaxcode/module-transfer-inv';
import connecttaxaxionevent from './connecttaxaxionevent/module-connect-taxaxion-event';
import supplieraccepttaxauthority from './supplieraccepttaxauthority/module-supplier-accept';
import emailreceivealert from './emailreceivealert/module-email-receive-alert';
import invoicecheckhistory from './invoiceCheckHistory/module-invoice-check-history';
import report from './report/module-report';
import avareport from './avareport/module-ava-report';
import customsdeclaration from './customsdeclarations/module-customsdeclaration';
import confirmgoodsvatrate from './cofirmGoodsVatRate/module-comfirm-vat-rate';
import usersetup from './usersetup/module-usersetup';
import importModule from './import/module-import';
import acceptcheckingresult from './acceptCheckingResult/module-acceptcheckingresult';
import confirmBusiness from './confirmBusiness/module-confirm-business';
import subscriber from './subscriber/module-subscriber';
import intructionsvideo from './intructionvideo/module-intruction-video';
import criteriasetup from './criteriasetup/module-criteria-setup';
import abbreviationsetup from './abbreviationsetup/module-abbreviation-setup';
import analysisreport from './analysisReport/module-analysis-report';
import navigation from './navigation/module-navigation';
import sendtodeveloper from './sendtodeveloper/module-send-to-developer';
import notificationBanner from './module-notification-banner/module-notification-banner';

// Init instance of store
const store = new Vuex.Store({
	plugins: process.env.NODE_ENV !== 'production' ? [createVuexPersistance()] : [createVuexPersistance()],
	getters,
	mutations,
	state,
	actions,
	modules: {
		auth: auth,
		user: user,
		organization: organization,
		invoice: invoice,
		invoicefiles: invoicefiles,
		inbox: inbox,
		notification: notification,
		supplier: supplier,
		licenseinfo: licenseinfo,
		resource: resource,
		invoicesCheckingUpdate: invoicesCheckingUpdate,
		layout: layout,
		columnexport: columnexport,
		stick: stick,
		invoicetrial: invoicetrial,
		auditinglog: auditinglog,
		agreement: agreement,
		connectInvoice: connectInvoice,
		misaid: misaid,
		settingsystem: settingsystem,
		rolepermission: rolepermission,
		outinvoice: outinvoice,
		versionfeature: versionfeature,
		internal: internal,
		notificationuser: notificationuser,
		organizationtransferinvoice: organizationtransferinvoice,
		suppliernodowninv: suppliernodowninv,
		supplieronlydowninv: supplieronlydowninv,
		transferinvbytaxcode: transferinvbytaxcode,
		connecttaxaxionevent: connecttaxaxionevent,
		supplieraccepttaxauthority: supplieraccepttaxauthority,
		emailreceivealert: emailreceivealert,
		invoicecheckhistory: invoicecheckhistory,
		report: report,
		customsdeclaration: customsdeclaration,
		confirmgoodsvatrate: confirmgoodsvatrate,
		usersetup: usersetup,
		avareport: avareport,
		import: importModule,
		acceptcheckingresult: acceptcheckingresult,
		confirmBusiness: confirmBusiness,
		subscriber: subscriber,
		intructionsvideo: intructionsvideo,
		criteriasetup: criteriasetup,
		abbreviationsetup: abbreviationsetup,
		navigation: navigation,
		analysisreport: analysisreport,
		sendtodeveloper: sendtodeveloper,
		notificationBanner: notificationBanner
		//PPDANG:IMPORTANT: Thêm module mới vào đây thì bắt buộc phải bổ sung vào hàm getAllDefaultStates trong file default-state-factory.js
		//PPDANG:IMPORTANT: Chỉ được thêm trên comment, không được thêm ở dưới, không được xóa comment này
	},
	strict: false
});

export default store;
